<template>
  <div id="app" style="background: #f7f8fa; height:100vh;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
